import { useCallback } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  CommentaireRequestDto,
  CommentaireResponseDto,
} from 'lib_api/lib/api/gen';

import { SubmitFunction } from 'components/BaseForm/types';
import { useApi } from 'hooks/ApiStoreContext';
import { backAlertMessage } from 'hooks/utils/backAlertMessage';
import { sortCommentaireListDtoByDateDesc } from 'utils/commentaireUtils';

export function useDeleteCommentaire(
  commentaireId: string,
  dossierId: string,
  close: () => void,
): SubmitFunction<CommentaireRequestDto> {
  const queryClient = useQueryClient();

  const { CommentaireControllerApi: controller } = useApi();
  const mutation = useMutation({
    mutationFn: () => controller.deleteUsingDELETE(commentaireId, dossierId),
    onSuccess: (commentaires: CommentaireResponseDto[]) => {
      return queryClient.setQueryData(
        ['commentaires', dossierId],
        sortCommentaireListDtoByDateDesc(commentaires),
      );
    },
    onSettled: () => {
      close();
    },
    onError: (error: Response) => {
      void queryClient.invalidateQueries({
        queryKey: ['commentaires', dossierId],
      });
      void backAlertMessage(error);
    },
  });

  const submit = useCallback(() => {
    return mutation.mutate();
  }, [mutation]);

  return {
    submit: submit,
    inProgress: mutation.isPending,
  };
}
